<template>
  <form @submit.prevent="shipmentAction">
    <div class="row">
      <div class="col-sm-6">
        <div class="mb-3">
          <label>Product</label>
          <input v-model="shipment.productId" readonly disabled class="form-control"/>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="mb-3">
          <label>Warehouse</label>
          <input v-model="shipment.warehouseId" readonly disabled class="form-control"/>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="mb-3">
          <label>Quantity</label>
          <input v-model="shipment.quantity" readonly disabled class="form-control"/>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="mb-3">
          <label>B/L</label>
          <input v-model="shipment.orderId" name="name" type="text" class="form-control"/>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="mb-3">
          <label>Date Ordered</label>
          <date-picker v-model="shipment.dateOrdered" format="YYYY-MM-DD" valueType="format"></date-picker>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="mb-3">
          <label>Expiry Date</label>
          <date-picker v-model="shipment.expiryDate" format="YYYY-MM-DD" valueType="format" ></date-picker>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="mb-3">
          <label>Purchase Price</label>
          <input v-model="shipment.orderPrice" name="name" type="text" class="form-control"/>
        </div>
      </div>
    </div>
    <div v-for="(error, index) in stockErrors" :key="index" style="color: #D13704;">
      {{error.message}}
    </div>
    <div class="mt-3 col-12">
      <b-button variant="primary" size="lg" class="py-3 h3 w-100" disabled v-if="stockLoading">
        <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
        Loading
      </b-button>
      <b-button variant="primary" size="lg" class="py-3 h3 w-100 text-white" type="submit" v-else>
        {{ button_text }}
      </b-button>
    </div>
  </form>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import {ALL_WAREHOUSES} from "@/gql/stock";
import {mapGetters} from "vuex";
export default {
  name: "update-shipment-form",
  setup () {
    return { v$: useVuelidate() }
  },
  data(){
    return {
      shipment: this.selected_shipment,
      productSearchKeyword: "",
      warehouses: {
        objects: []
      },
    }
  },
  apollo: {
    warehouses: {
      query: ALL_WAREHOUSES,
      variables(){
        return {
          page: 1,
          perPage:30
        }
      }
    },
  },
  computed: {
    ... mapGetters({
      stockLoading: 'stock/stockLoading',
      stockErrors: 'stock/stockErrors'
    }),
  },
  props: {
    button_text: {type: String},
    selected_shipment: {
      type: Object,
      default (){
        return {
          productId: "",
          warehouseId: "",
          orderId: "",
          dateOrdered: "",
          expiryDate: "",
          quantity: "",
          orderPrice: ""
        }
      }
    }
  },
  methods: {
    async shipmentAction() {
      const data = {
        orderId: this.shipment.orderId,
        productId: this.shipment.productId,
        warehouseId: this.shipment.warehouseId,
        quantity: parseInt(this.shipment.quantity),
        orderPrice: parseInt(this.shipment.orderPrice),
        dateOrdered: this.shipment.dateOrdered,
        expiryDate: this.shipment.expiryDate
      }

      this.$emit('shipmentAction', data)
      this.v$.$touch();
    },
  }
}
</script>

<style scoped>

</style>
